var React = require('react');

function HamburgerInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"hamburger.inline"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"hamburger.inline","fill":"#000000","fillRule":"nonzero"},[React.createElement("rect",{"id":"Rectangle","x":"0","y":"150.5","width":"455","height":"30","key":0}),React.createElement("rect",{"id":"Rectangle","x":"0","y":"0.5","width":"455","height":"30","key":1})]))]);
}

HamburgerInline.defaultProps = {"width":"455px","height":"181px","viewBox":"0 0 455 181","version":"1.1"};

module.exports = HamburgerInline;

HamburgerInline.default = HamburgerInline;
